import { useState } from "react";
import { faqItems } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Najczęściej zadawane pytania
          </h2>
          <p className="text-base text-foreground-600">
            Odpowiedzi na najważniejsze pytania dotyczące doradztwa kredytowego i procesu współpracy.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col gap-3">
            {faqItems.slice(0, 4).map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-800">
                    {item.question}
                  </span>
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full bg-background-100 shrink-0 transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-foreground-500" />
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="tel:698084044"
              className="inline-flex px-6 py-3 border-2 border-primary-500 text-primary-500 font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Zadzwoń – odpowiem na pytania
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}